import { useTranslation } from "react-i18next";
import { useState } from "react";
import styled from "styled-components";
import DownloadModal from "./DownloadModal";
import { TBannerType } from "@/typings/Props";

const ResultSheetGuideWrap = styled.div`
  width: 100%;
  height: 668px;
  display: flex;
  gap: 30px;
  padding: 30px;
`;
const Area = styled.div<{ $bgColor?: string }>`
  width: 50%;
  display: flex;
  align-items: center;
  border-radius: 10px;
  background-color: ${({ $bgColor }) => $bgColor};
  @media (max-width: 1300px) {
    &#imgArea {
      display: none;
    }
    width: 100%;
  }
`;
const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;
const TextWrap = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;
const Title = styled.p`
  font-size: 2.6rem;
  color: #444444;
  font-weight: 700;
  text-align: center;
  margin-bottom: 30px;
  white-space: pre-wrap;
`;
const Desc = styled.p`
  color: #676767;
  text-align: center;
  line-height: 150%;
  margin-bottom: 15px;
  white-space: pre-wrap;
`;
const DownloadBtn = styled.button`
  width: 160px;
  height: 40px;
  display: flex;
  padding: 10px;
  flex-direction: column;
  align-items: center;
  margin-right: 50px;
  font-weight: 700;
  border-radius: 20px;
  margin: auto;
  background-color: black;
  color: white;
  cursor: pointer;
  border: none;
  transition: 0.3s ease-out;
  @media (max-width: 460px) {
    margin: auto;
    margin-bottom: 15px;
  }
  &:hover {
    background-color: #971b2f;
    transition: 0.3s ease-out;
  }
`;

export default function ResultSheetGuide({ bannerData }: { bannerData?: TBannerType }) {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  return (
    <>
      <ResultSheetGuideWrap>
        <Area id="imgArea" $bgColor="#971b2f">
          <Image src="/learn/result-interpretation/image-138.webp" />
        </Area>
        <Area $bgColor="white">
          <TextWrap>
            <Title dangerouslySetInnerHTML={{ __html: t("menu.learn.result.guide.title") }}></Title>
            <Desc data-aos="fade-up" data-aos-easing="ease-out" data-aos-delay="200" data-aos-duration="500">
              {t("menu.learn.result.guide.desc")}
            </Desc>
            <DownloadBtn onClick={() => setIsModalOpen(true)}>{t("menu.learn.result.download-btn")}</DownloadBtn>
          </TextWrap>
        </Area>
      </ResultSheetGuideWrap>
      <DownloadModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        modalTitle={bannerData && bannerData.title}
      />
    </>
  );
}
